export const PATHS = {
  AUTH: {
    ROOT: "/auth",
    SIGN_IN: "/auth/sign-in",
    SIGN_UP: "/auth/sign-up",
    SSO: "/auth/sso",
    TOKEN: "/auth/token",
    // NOTE: This path is used for the forgot password feature.
    FORGOT_PASSWORD: "/auth/forgot-password", // NOSONAR
    // NOTE: This path is used for the reset password feature.
    RESET_PASSWORD: "/auth/reset-password", // NOSONAR
    // NOTE: Public accept-invite landing for pending email invitations
    // (NSAI-4021). Reads ?token= from the query string.
    ACCEPT_INVITE: "/auth/accept-invite",
  },
  CHAT: "/chat",
  // NOTE: NSAI-5657 / NSAI-5658 — saved dashboards (pages saved from chat).
  // Must match DASHBOARDS_ROUTE_PATH / buildDashboardRoutePath in
  // frontend-shared, which the viewer links are built with.
  DASHBOARDS: "/dashboards",
  DASHBOARD_DETAIL: "/dashboards/:dashboardUuid",
  SHARED_CHAT: "/shared/chat/:shareToken",
  // NOTE: NSAI-5823 — the public (no-account) chat viewer. Separate from
  // SHARED_CHAT above: that page assumes a signed-in session, this one opens
  // with a password prompt and is reachable signed-out.
  SHARED_PUBLIC_CHAT: "/shared/public-chat/:shareToken",
  // NOTE: Public, password-gated meeting viewer for people without an NSAI
  // account (NSAI-3853). Rendered outside the authenticated route tree.
  SHARED_MEETING: "/shared/meeting/:shareToken",
  // NOTE: Public, password-gated viewer for an AI-generated page (NSAI-5827).
  // Same shape as the meeting viewer above and likewise outside the
  // authenticated route tree. Must match PAGE_PUBLIC_SHARE_VIEWER_PATH, which
  // the server uses to build the absolute shareUrl.
  SHARED_PAGE: "/shared/page/:shareToken",
  AGENTS: "/agents",
  ANONYMIZATION_LAB: "/anonymization-lab",
  ASSISTANTS: "/assistants",
  MODELS: "/models",
  NEW_ASSISTANT: "/assistants/new",
  EDIT_ASSISTANT: "/assistants/:assistantId",
  KNOWLEDGE: "/knowledge",
  DOC_RECOGNITION: "/doc-recognition",
  DOC_RECOGNITION_DOCUMENT: "/doc-recognition/:documentUuid",
  AI_GENERATED_FILES: "/ai-generated-files",
  // NOTE: NSAI-5656 — a generated HTML page opened in its own window. Rendered
  // outside the app shell (no sidebar) but behind ProtectedRoute: the page is
  // fetched through the owner-only chat file endpoint. `?name=` carries the
  // file name for the tab title and the download action.
  HTML_PREVIEW: "/html-preview/:fileUuid",
  // NOTE: NSAI-3306 — Agent Skills management. Gated behind the isSkillsEnabled
  // app-config flag AND a private/public skill read permission; see
  // src/routes/index.tsx.
  SKILLS: "/skills",
  SKILL_NEW: "/skills/new",
  // NOTE: NSAI-3311 — the Organization Catalog. A static segment outranks
  // "/skills/:skillUuid" in React Router regardless of declaration order, so it
  // can live under the Skills root even though a catalog entry is
  // organization-scoped rather than project-scoped.
  SKILL_CATALOG: "/skills/catalog",
  SKILL_CATALOG_ENTRY: "/skills/catalog/:entryUuid",
  SKILL_DETAIL: "/skills/:skillUuid",
  SKILL_EDIT: "/skills/:skillUuid/edit",
  INTEGRATIONS: "/integrations",
  INTEGRATION_DETAILS: "/integrations/:provider",
  CUSTOM_INTEGRATION_NEW: "/integrations/custom/new",
  CUSTOM_INTEGRATION_EDIT: "/integrations/custom/:uuid",
  TRELLO_CALLBACK: "/integration/trello/callback",
  PROMPT_LIBRARY: "/prompt-library",
  ANALYTICS: "/analytics",
  CALL_ASSISTANT: "/call-assistant",
  MEETING_DETAILS: "/call-assistant/:meetingUuid",
  UPLOADS: "/uploads",
  CHAT_FOLDERS: "/chat-folders",
  SETTINGS: "/settings",
  FAQ: "/faq",
  // NOTE: Not an SPA route — served by Caddy/Vite's forward_auth proxy to the
  // Docusaurus site, so it must be a full-page <a href>, never a NavLink.
  DOCS: "/docs",
  // NOTE: Deep links into the docs portal. The docs site is mounted at /docs
  // with routeBasePath "/", so a page at nsai-docs/docs/<path>.mdx is served
  // from /docs/<path>.
  DOCS_EMBEDDING_MODELS: "/docs/features/embedding-models",
  LICENSE_EXPIRED: "/license-expired",
  NOT_FOUND: "/not-found",
  NO_PROJECTS: "/no-projects",
  ADMIN: {
    ROOT: "/admin",
    AUTH: {
      SIGN_IN: "/admin/auth/sign-in",
    },
    DASHBOARD: "/admin/dashboard",
    USERS: "/admin/users",
    USER_DETAIL: "/admin/users/:uuid",
    ORGANIZATIONS: "/admin/organizations",
    ORGANIZATION_DETAIL: "/admin/organizations/:uuid",
    PROJECTS: "/admin/projects",
    PROJECT_DETAIL: "/admin/projects/:uuid",
    MODELS: "/admin/models",
    MODEL_DETAIL: "/admin/models/:uuid",
    ASSISTANTS: "/admin/assistants",
    ASSISTANT_DETAIL: "/admin/assistants/:uuid",
    PROBES: "/admin/probes",
    PROBE_DETAIL: "/admin/probes/:uuid",
    ROLES: "/admin/roles",
    ROLE_DETAIL: "/admin/roles/:uuid",
    CHATS: "/admin/chats",
    CHAT_DETAIL: "/admin/chats/:uuid",
    KNOWLEDGE: "/admin/knowledge",
    KNOWLEDGE_DETAIL: "/admin/knowledge/:uuid",
    MEETINGS: "/admin/meetings",
    MEETING_DETAIL: "/admin/meetings/:uuid",
    EXTERNAL_API_KEYS: "/admin/external-api-keys",
    EXTERNAL_API_KEY_DETAIL: "/admin/external-api-keys/:uuid",
    AUDIT_LOGS: "/admin/audit-logs",
    ACCOUNTS: "/admin/accounts",
    SESSIONS: "/admin/sessions",
    INTEGRATIONS: "/admin/integrations",
    INTEGRATION_DETAIL: "/admin/integrations/:uuid",
    USER_SESSIONS: "/admin/user-sessions",
    ACTIVITY_LOG: "/admin/activity-log",
    APPEARANCE: "/admin/appearance",
    SSO_DOMAINS: "/admin/sso-domains",
    SETTINGS: "/admin/settings",
    /** Admin cron jobs list; run history lives on each job’s detail page. */
    AUTOMATIONS: "/admin/automations",
    CRON_JOB_DETAIL: "/admin/automations/cron-jobs/:uuid",
  },
  SELECT_PLAN: "/select-plan",
};
